import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';


export interface statusCode {
  status: number;
  name: string;
  meaning: string;
}

const SuccessCode: statusCode[] = [
  {
    status: 200,
    name: 'Ok',
    meaning: 'Successful Request',
  },
  {
    status: 201,
    name: 'No Content',
    meaning: 'Successful with No response',
  }
];
const ErrorCode: statusCode[] = [
  { status: 400,	name: "Bad Request", meaning: "Malformed request or source not available"},
  { status: 401,	name: "Unauthorized", meaning: "Invalid authorization credentials"},
  { status: 403,	name: "Forbidden", meaning: "Action prohibited"},
  { status: 404,	name: "Not Found", meaning: "Resource not found"},
  { status: 500,	name: "Internal Server Error", meaning: "An unexpected error occurred in our API"},
  { status: 429,	name: "Limit Over", meaning: "Request over the limit"}
];

@Component({
  selector: 'app-authentication',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './authentication.component.html',
})
export class AuthenticationComponent {
  displayedColumns: string[] = ['status', 'name', 'meaning'];
  dataSource = SuccessCode;
  errordataSource = ErrorCode;

}
